import { FilterCondition } from '@/features/analyze/types';
import { removeEmptyValues } from '@/utils/removeEmptyValues';
import { getDefaultStore, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithHash } from 'jotai-location';

const KEYS_TO_DATE_PARSE = [
  'publishedStartAt',
  'publishedEndAt',
  'createdAt',
  'updatedAt',
];

export const filterConditionAtom = atomWithHash<FilterCondition>(
  'q',
  {},
  {
    serialize: (conditionObject) => {
      const notEmptyObject = removeEmptyValues(conditionObject);
      const jsonValue = JSON.stringify(notEmptyObject);

      return jsonValue === '{}' ? '' : jsonValue;
    },
    deserialize: (val) => {
      try {
        return JSON.parse(val, (key, value) => {
          if (KEYS_TO_DATE_PARSE.includes(key) && typeof value === 'string') {
            return new Date(value);
          }
          // other
          return value;
        }) as FilterCondition;
      } catch {
        return {};
      }
    },
  }
);

export const useFilterConditionAtom = () => useAtom(filterConditionAtom);

export const useFilterConditionAtomValue = () =>
  useAtomValue(filterConditionAtom);

export const useSetFilterConditionAtom = () => useSetAtom(filterConditionAtom);

export const filterConditionListener = (listener: () => void) => {
  const store = getDefaultStore();
  return store.sub(filterConditionAtom, listener);
};
